import { internalInstance } from '../../utils/httpinstance';
import AbortController from 'abort-controller';

export const ADD_PORT_FILTER = 'ADD_PORT_FILTER';
export const REMOVE_PORT_FILTER = 'REMOVE_PORT_FILTER';
export const SET_PORT_FILTER = 'SET_PORT_FILTER';
export const CLEAR_PORT_FILTERS = 'CLEAR_PORT_FILTERS';
export const GET_CHARITY_START = 'GET_CHARITY_START';
export const GET_CHARITY_SUCCESS = 'GET_CHARITY_SUCCESS';
export const GET_CHARITY_ERROR = 'GET_CHARITY_ERROR';

let abortController;

export const setFilters = filters => {
    return async dispatch => {
        dispatch({
            type: SET_PORT_FILTER,
            payload: {
                filters: filters,
            },
        });
    };
};

export const removeFilter = filter => {
    return async dispatch => {
        dispatch({
            type: REMOVE_PORT_FILTER,
            payload: {
                filter: filter,
            },
        });
    };
};

export const addFilter = filter => {
    return async dispatch => {
        dispatch({
            type: ADD_PORT_FILTER,
            payload: {
                filter: filter,
            },
        });
    };
};

export const clearFilters = type => {
    return async dispatch => {
        dispatch({
            type: CLEAR_PORT_FILTERS,
            payload: {
                type: type,
            },
        });
    };
};

export const fetchCharity = (page, filters, sort, append = false) => {
    if (abortController) {
        abortController.abort();
    }
    abortController = new AbortController();
    return async dispatch => {
        dispatch({ type: GET_CHARITY_START });
        await internalInstance
            .get(`/api/charity?page=${page}&filters=${filters}&sort=${sort}`, {
                signal: abortController.signal,
            })
            .then(res => {
                dispatch({
                    type: GET_CHARITY_SUCCESS,
                    payload: {
                        data: res.data,
                        append,
                    },
                });
            })
            .catch(() => {
                dispatch({ type: GET_CHARITY_ERROR });
            });
    };
};
